export const LOGGING_ENABLED_KEY = 'loggingEnabled';

export const Logger = {
  log: (...args: any) => {
    if (localStorage.getItem(LOGGING_ENABLED_KEY) === 'true') {
      }
  }
};
